const NETWORK_ERROR = 'Сервис временно недоступен. Проверьте подключение к интернету и повторите попытку.';

export function clientErrorMessage(error: unknown, fallback: string): string {
  const raw = error instanceof Error
    ? error.message.trim()
    : typeof error === 'string'
      ? error.trim()
      : '';

  if (!raw) return fallback;

  const normalized = raw.toLowerCase();

  if (/failed to fetch|networkerror|network error|load failed|econnrefused|connection refused/.test(normalized)) {
    return NETWORK_ERROR;
  }
  if (/timeout|timed out|operation was aborted|aborterror/.test(normalized)) {
    return 'Сервис отвечает слишком долго. Повторите попытку через несколько минут.';
  }
  if (/too many requests|http 429|status.?429/.test(normalized)) {
    return 'Слишком много запросов. Подождите несколько минут и повторите попытку.';
  }
  if (/unauthorized|http 401|status.?401/.test(normalized)) {
    return 'Сессия истекла. Войдите в аккаунт повторно.';
  }
  if (/forbidden|http 403|status.?403/.test(normalized)) {
    return 'Это действие недоступно для вашего аккаунта.';
  }
  if (/kyc is not approved|kyc not verified|needcompletekyc|провер(ка|ку) личности|kyc не пройден|не подтвердил kyc/.test(normalized)) {
    return 'Сначала завершите проверку личности в профиле.';
  }
  if (/sbp blocked|too_many_unpaid_invoices|слишком много неоплаченных/.test(normalized)) {
    return 'Оплата через СБП временно недоступна. Проверьте предыдущие платежи или обратитесь в поддержку.';
  }
  if (/min amount is|минимальная сумма/.test(normalized)) {
    const amount = raw.match(/(?:min amount is|минимальная сумма(?: платежа)?[:\s]*)\s*([\d.,]+)/i)?.[1];
    return amount ? `Минимальная сумма платежа: ${amount.replace('.', ',')} ₽.` : 'Указанная сумма меньше минимальной.';
  }
  if (/max amount is|максимальная сумма/.test(normalized)) {
    const amount = raw.match(/(?:max amount is|максимальная сумма(?: платежа)?[:\s]*)\s*([\d.,]+)/i)?.[1];
    return amount ? `Максимальная сумма платежа: ${amount.replace('.', ',')} ₽.` : 'Указанная сумма превышает максимальную.';
  }
  if (/promo|промокод/.test(normalized)) {
    return 'Промокод не найден или больше не действует.';
  }
  if (/already exists|уже зарегистрирован|email.*занят/.test(normalized)) {
    return 'Аккаунт с таким email уже зарегистрирован.';
  }

  const technical = /invalidfullsign|full_sign|api[-_ ]?key|api-ключ|bitbanker|partner-client|invoice|http 5\d\d|status.?5\d\d|internal error|внутренняя ошибка|stack trace|exception|payment service/i;
  if (technical.test(raw)) return fallback;

  return /[А-Яа-яЁё]/.test(raw) ? raw : fallback;
}
